var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCategory = function SvgCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5a.5.5 0 0 0 0 1h16a.5.5 0 0 0 0-1H4Zm0 4a.5.5 0 0 0 0 1h16a.5.5 0 0 0 0-1H4Zm-.5 4.5A.5.5 0 0 1 4 13h6a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5ZM13 15a.5.5 0 0 0 0 1h2.5v2.5a.5.5 0 0 0 1 0V16H19a.5.5 0 0 0 0-1h-2.5v-2.5a.5.5 0 0 0-1 0V15H13Zm-9 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H4Z",
    fill: "#0F55ED"
  })));
};

export default SvgCategory;